import { cn } from "@klarify/ui/lib/utils";
import type { VariantProps } from "class-variance-authority";
import { cva } from "class-variance-authority";
import type * as React from "react";

const badgeVariants = cva(
	"inline-flex items-center rounded-md border px-2.5 py-0.5 font-semibold text-xs transition-colors focus:outline-hidden focus:ring-2 focus:ring-ring focus:ring-offset-2",
	{
		variants: {
			variant: {
				default:
					"border-transparent bg-primary text-primary-foreground shadow hover:bg-primary/80",
				secondary:
					"border-transparent bg-secondary text-secondary-foreground hover:bg-secondary/80",
				destructive:
					"border-transparent bg-destructive text-destructive-foreground shadow hover:bg-destructive/80",
				outline: "text-foreground",
				payments:
					"h-fit rounded-sm bg-klarify-forest-600 text-white hover:bg-klarify-forest-600/80",
				paymentsOrange:
					"h-fit rounded-sm bg-klarify-peach-500 text-white hover:bg-klarify-peach-400/80",
				pillMuted:
					"rounded-full border-transparent bg-klarify-cloud-100 px-2 py-0.5 font-medium text-sidebar-muted text-sm",
				pillSuccess:
					"rounded-full border-transparent bg-klarify-forest-50 px-2 py-0.5 font-semibold text-klarify-forest-700 text-sm",
				pillDestructive:
					"rounded-full border-transparent bg-klarify-rose-100 px-2 py-0.5 font-semibold text-klarify-rose-700 text-sm",
				pillOcean:
					"rounded-full border-transparent bg-klarify-ocean-50 px-2 py-0.5 font-semibold text-klarify-ocean-700 text-xs capitalize",
				pillPeach:
					"rounded-full border-transparent bg-klarify-peach-50 px-2 py-0.5 font-semibold text-klarify-peach-700 text-xs capitalize",
			},
		},
		defaultVariants: {
			variant: "default",
		},
	},
);

export interface BadgeProps
	extends React.ComponentProps<"div">,
		VariantProps<typeof badgeVariants> {}

function Badge({ className, variant, ...props }: BadgeProps) {
	return (
		<div
			className={cn(badgeVariants({ variant }), className)}
			{...props}
		/>
	);
}

export { Badge, badgeVariants };
